import React from "react";
import MediaContentItem, {
	type MediaContentItemProps,
} from "../../../components/MediaContentItem/MediaContentItem";
import WrappedSection from "../../WrappedSection/WrappedSection";
import * as styles from "./ParagraphMediaContentList.module.scss";

export interface ParagraphMediaContentListProps {
	mediaContentItems: MediaContentItemProps[];
}

export const getParagraphMediaContentListProps = ({
	relationships: { field_media_content_item },
}: Queries.ParagraphMediaContentListDataFragment): ParagraphMediaContentListProps => ({
	mediaContentItems: field_media_content_item.map((mediaContentItem) => ({
		title: mediaContentItem.field_heading,
		text: mediaContentItem.field_text.value,
		image: mediaContentItem.relationships.field_featured_image,
		imgAlt:
			mediaContentItem.relationships?.field_featured_image?.field_media_image
				?.alt,
		imgSrc:
			mediaContentItem.relationships?.field_featured_image?.field_media_image
				?.uri,
	})),
});
export const ParagraphMediaContentList: React.FC<
	ParagraphMediaContentListProps
> = ({ mediaContentItems }) => {
	return (
		<>
			<WrappedSection sectionName="ParagraphMediaContentList">
				<div className={styles.paragraphmediacontentlistinner}>
					{mediaContentItems.map((item) => (
						<MediaContentItem key={item.title} {...item} />
					))}
				</div>
			</WrappedSection>
		</>
	);
};

export default ParagraphMediaContentList;
